// PrivacyPolicyPage.jsx

import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="container text-justify mx-auto mt-8 p-8 ">
      <h2 className="text-3xl font-bold lg:text-5xl text-palette1 mb-6">
        Privacy Policy
      </h2>

      <div className="text-lg text-palette3 mb-6">
        <p>
          This Privacy Policy outlines that Dream Innovation Srl does not
          collect any personal information from users visiting the
          www.dreaminnovation.it website.
        </p>
      </div>

    

      <div className="text-lg text-palette3 mb-6">
        <p>
          Our Site may contain links to external websites that are not operated
          by us. Please be aware that we have no control over the content and
          practices of these sites and cannot accept responsibility or liability
          for their privacy policies.
        </p>
      </div>


      <div className="text-lg text-palette3 mb-6">
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at info@dreaminnovation.it.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
